import { globalStore } from "../../main.js";
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
import VModal from 'vue-js-modal'
import UserMethods from '../../shared/userMethods.js'
import Vue from 'vue'

Vue.use(VModal, { dialog: true });

export default {
	name: "usersList",
	components: {
    PulseLoader
  },
  data() {
    return {
      fullView: false,
      users: [],
      totalUsersCount: 0,
      filteredUsersCount: 0,
      usersCount: 0,
			loadMoreBusy: true,
			loadingUsers: false,
      hasQuickSearch: false,
			quickSearchText: "",
			sortBy: 'LastName',
			sortOrder: true, //true = A-Z,
			languageOptions: globalStore.culture.languages,
			languageFilterValue: [],
			userStatusValue: [],
			groupsFilterOptions: [],
			groupsFilterValue: [],
			userImplementationValue: [],
			userType: [],
			mmpwmLocations: [],
			physicalLocation: [],
			loadFlags: {
				settings: true,
				users: true
			},
			skipDataUpdate: false,
			searchUsed: false,
			showEmailSpinner: false,
			defaultUserTypes: ['0', '10', '50', '99', '601']
    };
	},
  created: function() {
    globalStore.openedSubPoint = this.$parent.usersListText;
		globalStore.openedPoint = this.$parent.actionText;
		globalStore.isFiltersActive = true;
			
		this.getFiltersSettings();

		if (this.isCurrentUserAdmin) {
			this.userImplementationValue = [this.userImplementOptions[0]];	
		} else if (this.isCurrentUserMMPWM) {
			this.userImplementationValue = [this.userImplementOptions[2]];
		}

		this.userType = this.defaultUserTypes;
  },
  beforeCreate: function() {
    if (!this.$session.exists()) {
      this.$router.push("login");
    }
  },
  methods: {
		editUser: function(user){
			this.$router.push('/dashboard/userslist/' + user.Id);
		},
    createDigiUser: function(){
			this.$router.push('/dashboard/userslist/new');
    },
    createSharePointUser: function(){
        this.$router.push('/dashboard/userslist/newsharepoint');
		},
		createMMPDigiUser: function(){
			this.$router.push('/dashboard/userslist/newmmpdigi');
    },
		unlockUser: function(user){
			UserMethods.unlockUser(this, user.Id, () => {
				user.Locked = false;
			}); 	
		},
		activateUser: function(user, event){
			UserMethods.activateUser(this, user.Id, () => {
					user.IsActive = true;
			})	
		},
		setPassword: function(user){
			this.$router.push('/dashboard/setPassword/' + user.Id);
		},
		deactivateUser: function(user, event){
			UserMethods.deactivateUser(this, user.Id, () => {
					user.IsActive = false;
			})
		},
		sendWelcomeEmail: function(user, appType, noPasswd){
			UserMethods.sendWelcomeEmail(this, user.Id, user.PreferredLanguage, appType, noPasswd);
		},
		getWelcomeEmailPreview: function(user, appType, noPasswd) {
			var self = this;
			self.showEmailSpinner = true;
			var html = UserMethods.getWelcomeEmailPreview(this, user.Id, appType, noPasswd)
					.then(response => {			
							self.showEmailSpinner = false;
							self.$modal.show('dialog', {
									text: response.data,
									buttons: []
							})
					})
					.catch(err => {
							self.showEmailSpinner = false;
							console.log(err);
							globalStore.showInfo(null, this.labels().ERROR_EMAIL_GENERATE, 'danger');
					});	
	},
		sendForgotPasswordEmail: function(user, appType){
			UserMethods.sendForgotPasswordEmail(this, user.Id, user.PreferredLanguage, appType);
		},
		getForgotPasswordEmailPreview: function(user, appType) {
			var self = this;
			self.showEmailSpinner = true;
			var html = UserMethods.getForgotPasswordEmailPreview(this, user.Id, appType)
					.then(response => {			
							self.showEmailSpinner = false;
							self.$modal.show('dialog', {
									text: response.data,
									buttons: []
							})
					})
					.catch(err => {
							self.showEmailSpinner = false;
							console.log(err);
							globalStore.showInfo(null, this.labels().ERROR_EMAIL_GENERATE, 'danger');
					});	
	},
	toogleSortOrder: function(){
		this.sortOrder = !this.sortOrder;
		this.resetUsersData();
        this.getUsers();
	},
	sortByChange: function(){
		this.resetUsersData();
        this.getUsers();
	},
	resetUsersData: function(){
		this.users = [];
		this.usersCount = 0;
		this.totalUsersCount = 0;
		this.filteredUsersCount = 0;
		this.searchUsed = true;
	},
	makeSearch: function() {
		  if (this.userImplementationValue.length == 0) {
				return;
			}
			this.hasQuickSearch = this.quickSearchText.length > 0;
			this.resetUsersData();
			this.getUsers();
	},
	resetFilters: function(){
		var self = this;

		this.skipDataUpdate = true;

		this.languageFilterValue = [];
		this.userStatusValue = [];
		this.groupsFilterValue = [];
		if (this.isCurrentUserAdmin) {
			this.userImplementationValue = [this.userImplementOptions[0]];	
		} else if (this.isCurrentUserMMPWM) {
			this.userImplementationValue = [this.userImplementOptions[2]];	
		} else {
			this.userImplementationValue = [];
		}
		this.physicalLocation = [];
		this.userType = this.defaultUserTypes;

		Vue.nextTick(function () {
			self.skipDataUpdate = false;
			self.resetQuickSearch();
		});
	},
    resetQuickSearch: function() {
			this.hasQuickSearch = false;
      this.quickSearchText = "";

      this.resetUsersData();
      this.getUsers();
    },
    getFiltersData: function() {
			var language = this.languageFilterValue.map(function(item){
				return item.code;
			}).join(',');

			var userState = 0;
			if(this.userStatusValue.length === 1) {
				var usrStatus = this.userStatusValue[0].value;
				if(usrStatus === 'enabled'){
					userState = 1;
				} else if (usrStatus === 'disabled') {
					userState = 2;
				} else {
					userState = 3;
				}
			}
			var userImplement = 0;
			if(this.userImplementationValue.length === 1){
					var implVal = this.userImplementationValue[0].value;
			    if (implVal === 'mmid') {
			    	userImplement = 1;
					} else if (implVal === 'sharepoint') {
			    	userImplement = 2;
					} else if (implVal === 'mmpwm') {
						userImplement = 3;
					}
			}
			
			var memberOf = this.groupsFilterValue.map(function(item){
				return item.value;
			});

      return {
				PageSize: 15,
				Skip: this.usersCount,			
				SortBy: this.sortBy,
				SortOrder: this.sortOrder ? 'ASC' : 'DESC',
				Filter:{
					QuickSearch: this.quickSearchText,
					PreferredLanguage: language,
					UserState: userState,
					MemberOf: memberOf,
					UserImplement: userImplement,
					PhysicalLocation: this.physicalLocation.length == 1 ? this.physicalLocation[0] : '',
					UserTypes: this.userType
				}       
      };
    },
    toogleFilters: function() {
      globalStore.isFiltersActive = !globalStore.isFiltersActive;
    },
    loadMore: function() {
			if (!this.loadMoreBusy) {
        console.log("loadMore");
        this.getUsers();
      }
    },
    getUsers: function() {
			this.loadMoreBusy = true;
      var self = this;
      const apiUrl = globalStore.host + "UsersList";

			self.loadingUsers = true;
			self.$axios
				.post(apiUrl, self.getFiltersData(), {
					headers: { Authorization: "Bearer " + self.$session.get("jwt") }
				})
				.then(response => {					
					if (response.status === 200) {
						response.data.Users.forEach(function(item, i) {
							self.users.push(self.enrichUserData(item));
							self.usersCount = self.usersCount + 1;
						});
						self.filteredUsersCount = response.data.FilteredCount;
						self.totalUsersCount = response.data.TotalCount;

						self.loadFlags.users = true;
					}
					
					if(self.usersCount < self.filteredUsersCount){
						self.loadMoreBusy = false;
					}
				})
				.catch(err => {
					self.loadMoreBusy = false;
					console.log(err);
					if (err.response && err.response.status === 401) {
						self.$session.destroy();
						self.$router.push("/login");
					}
					return err;
				})
				.then(() => {
					self.loadingUsers = false;
				});
		},
		getFiltersSettings: function(){
			this.loadFlags.settings = true;
			this.groupsFilterOptions = globalStore.userListGroups.map(function(item){
				return {label: item, value: item};
			});
			if (this.isCurrentUserMMPWM) {
				// get locations
				var self = this;
				self.$axios
					.get(globalStore.host + "MMPWMLocations", {
						headers: { Authorization: "Bearer " + self.$session.get("jwt") }
					})
					.then(response => {
						if (response.status === 200) {
							self.mmpwmLocations = response.data;
						}
					})
					.catch(err => {
						console.log(err);
						if (err.response && err.response.status === 401) {
							self.$session.destroy();
							self.$router.push("/login");
						}
						return err;
					})
			}
		},
    toggleUserView: function() {
      var self = this;
      this.fullView = !this.fullView;
      this.users.forEach(function(item, i, arr) {
        item.viewModel.fullView = self.fullView;
      });
    },
    enrichUserData: function(user) {
      var userModel = {};

      userModel.Id = user.AccountName;
			userModel.PrincipalName = user.PrincipalName;
			userModel.AccountName = user.AccountName;
      userModel.Email = user.Email;
      userModel.OrganizationUnit = user.OrganizationUnit;
      userModel.FirstName = user.FirstName;
      userModel.LastName = user.LastName;
      userModel.PreferredLanguage = user.PreferredLanguage;
			userModel.IsActive = user.Enabled;
			userModel.Locked = user.Locked;
			userModel.IsSharePointUser = user.IsSharePointUser;
			userModel.Groups = user.Groups;
			userModel.Domain = user.Domain
			userModel.Company = user.Company;
			userModel.HasDigiGroups = user.HasDigiGroups;
			userModel.HasSharePointGroups = user.HasSharePointGroups;
			userModel.HasMMPDigiGroups = user.HasMMPDigiGroups;
			userModel.ExtensionAttribute6 = user.ExtensionAttribute6;
			userModel.CanonicalName = user.CanonicalName;
      userModel.viewModel = {};
			userModel.viewModel.fullView = this.fullView;

      return userModel;
		}
  },
  computed: {
    openedSubPoint: function() {
      return this.labels.USERS_LIST_TEXT;
    },
    openedPoint: function() {
      return this.labels.ACTION_TEXT;
		},
		isFiltersActive: function(){
			return globalStore.isFiltersActive;
		},
		userStatusOptions: function(){
			return [ {value: "enabled", label: this.labels.ACTIVE}, {value: "disabled", label: this.labels.INACTIVE}, {value: "locked", label: this.labels.LOCKED} ]
		},
		userImplementOptions: function(){
				return [ {value: "mmid", label: this.labels.MMID }, { value: "sharepoint", label: this.labels.EXTRANET },
				{ value: "mmpwm", label: "MMPWM" } ]
		},
		userTypes: function(){
				return [ '0','10','50','51','99','101','102','103','104','201','202','299','301','401','402','403','411','412','505','601','1001','1002','1005','1010','1020' ];
		},
		showSpinner: function(){
			return this.loadingUsers || this.loadFlags.settings == false || this.loadFlags.users == false;
		},
    labels: function() {
        return globalStore.culture.strings.UsersList;
		},
		isCurrentUserAdmin: function(){
      return globalStore.isCurrentUserAdmin;
    },
    isCurrentUserMMPWM: function() {
      return globalStore.isCurrentUserMMPWM;
		},
		isCurrentUserMMPWM_Admin: function() {
      return globalStore.isCurrentUserMMPWM_Admin;
    }
	},
	watch: {
		userImplementationValue: function(newVal) {
			if (newVal.length == 1 && newVal[0].value == 'mmpwm') {
				return;
			}
			this.physicalLocation = [];
		}
	}
};


// WEBPACK FOOTER //
// ./src/components/UsersList/UsersList.js